export default __webpack_public_path__ + "static/krasnoyarsk_small-02fc342412207f3d05fef092a25fba8c.jpg";